import { render, staticRenderFns } from "./DPEnvironmentPanel.vue?vue&type=template&id=525314a8&scoped=true&"
import script from "./DPEnvironmentPanel.vue?vue&type=script&lang=js&"
export * from "./DPEnvironmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./DPEnvironmentPanel.vue?vue&type=style&index=0&id=525314a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525314a8",
  null
  
)

export default component.exports